import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { OpportunitMarketReportResponse, OpportunitReportRequestModel } from '../models/usageReport'

export class GetOpportunitMarketReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/OpportunitMarketReport',
      requesterInfo,
    })
  }

  public async getReport(req: OpportunitReportRequestModel): Promise<OpportunitMarketReportResponse> {
    return await this.postAsync<OpportunitMarketReportResponse>(req)
  }
}